import { render } from "./header.vue?vue&type=template&id=e3812a46"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=e3812a46&lang=less"
script.render = render

export default script